import React, { useEffect } from "react";
import { Typography, Button } from "@mui/material";
import { AccountMenu } from "./Component/AccountMenu";
import { Player } from "video-react";
import "../node_modules/video-react/dist/video-react.css";
import { useLanguage } from "./Provider/LanguageProvider";
import { useAssets } from "./Provider/AssetProvider";
import "./Component/Asset.css";
import { useParams } from "react-router-dom";
import { Assessment } from "./Component/Assessment";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
//import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
//import DownloadDoneOutlinedIcon from "@mui/icons-material/DownloadDoneOutlined";

export function AssetDetail() {
  let { assetId } = useParams();
  const { assets } = useAssets();
  const { language } = useLanguage();

  let targetAsset = assets.find((asset) => asset.id === assetId);
  let keywordAry = targetAsset.keyword.split(",");

  useEffect(() => {
    console.log("increment local view Cnt");
    console.log(targetAsset.id);
    console.log(targetAsset.viewCnt);
    // increment local viewCnt
    // call CreateViewAsset(add view count on server)
    // when success
    // do nothing
    // when fail
    // reverse local viewCnt and ui
  }, []);

  //   const commonStyles = {
  //     bgcolor: "background.paper",
  //     border: 1.5,
  //     width: "300px",
  //     p: "10px",
  //     marginTop: "10px",
  //     marginBottom: "10px"
  //   };

  return (
    <div style={{ marginLeft: "20px" }}>
      <AccountMenu />
      <div className="asset-detail-grid">
        <article className="main">
          <Player
            src={targetAsset.movieUrl}
            fluid={true}
            // width={720}
            height={405}
            startTime={0.0}
          />
        </article>
        <section className="side">
          <div style={{ display: "flex" }}>
            <Typography
              variant="h4"
              color={"primary"}
              fontWeight={"bold"}
              noWrap
            >
              {targetAsset.title}
            </Typography>
            <Typography variant="h4" color={"gray.dark"} noWrap>
              &nbsp;{"/"}&nbsp;
            </Typography>
            <Typography variant="h4" color={"gray"} noWrap>
              {targetAsset.userId}
            </Typography>
          </div>
          <Typography variant="body1" color={"primary.light"}>
            created: {targetAsset.created.substr(0, 9)} updated:{" "}
            {targetAsset.updated.substr(0, 9)}
          </Typography>
          <div style={{ marginTop: "10px", marginBottom: "10px" }}>
            <div style={{ display: "flex" }}>
              <Typography
                variant="h5"
                fontWeight={"bold"}
                textAlign={"center"}
                color={"gray.dark"}
              >
                ${targetAsset.price}
              </Typography>
              <Typography
                color={"success.main"}
                variant="h5"
                fontWeight={"bold"}
                noWrap
              >
                &nbsp;&nbsp;{targetAsset.commercialUse == "0" ? "×" : "〇"}
              </Typography>
              <Typography variant="h5" color={"gray.dark"}>
                {language.AssetList_CommercialUse}&nbsp;&nbsp;
              </Typography>
              <InsertDriveFileOutlinedIcon color="gray" />
              <Typography variant="h6" color="gray.dark">
                {targetAsset.type}
              </Typography>
            </div>
            <Button
              variant="contained"
              color={"success"}
              onClick={() => {
                // add downloadCnt and update UI
                // call GetAssetFile
                // when success
                // call CreateDownloadAsset
                // when fail
                // reverse downloadCnt and UI
              }}
            >
              {language.AssetDetail_Download}
              <div className="asset-detail-download-btn-container"></div>
            </Button>
          </div>
          <Assessment
            viewCnt={targetAsset.viewCnt}
            downloadCnt={targetAsset.downloadCnt}
            goodCnt={targetAsset.goodCnt}
            isGood={false} // tmp test
          />
          <div style={{ marginTop: "10px" }}>
            {keywordAry.map((keyword, i) => (
              <Button
                key={i}
                variant="outlined"
                size="small"
                color="secondary"
                style={{ margin: "2px" }}
              >
                {keyword}
              </Button>
            ))}
          </div>
          <div style={{ marginTop: "10px" }}>
            <Typography>{targetAsset.description}</Typography>
          </div>
        </section>
      </div>
    </div>
  );
}
